export default __webpack_public_path__ + "static/media/reorderBackground.3bdee3d6.png";